import { createFileRoute } from '@tanstack/react-router'
import SerieContainer from 'Serie/containers/SerieContainer'
import { claimTypesEnum } from 'User/utils/claims'
import { Suspense } from 'react'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/series/list/')({
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_work]}>
            <Suspense fallback={<PageSkeleton variant="series" wrapper="main" />}>
                <SerieContainer />
            </Suspense>
        </Guard>
    ),
})
